var GeometryType;
(function (GeometryType) {
    GeometryType["CONTOUR"] = "CONTOUR";
    GeometryType["SURFACE"] = "SURFACE";
    GeometryType["MESH"] = "MESH";
})(GeometryType || (GeometryType = {}));
export default GeometryType;
